'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropDownMenu = require('common/components/drop-down-menu');

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _loginButton = require('./login-button');

var _loginButton2 = _interopRequireDefault(_loginButton);

var _signupButton = require('./signup-button');

var _signupButton2 = _interopRequireDefault(_signupButton);

var _topBarMenuLink = require('./top-bar-menu-link');

var _topBarMenuLink2 = _interopRequireDefault(_topBarMenuLink);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _topBarV = require('./experiments/top-bar-v2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TopBarMenu = _react2['default'].createClass({
    displayName: 'TopBarMenu',


    propTypes: {
        'topBarMenuLinkData': _react2['default'].PropTypes.array.isRequired,
        'dropDownMenuLinkData': _react2['default'].PropTypes.array.isRequired,
        'pageToHighLight': _react2['default'].PropTypes.string,
        'useWhite': _react2['default'].PropTypes.bool,
        'useBlack': _react2['default'].PropTypes.bool,
        'isCompact': _react2['default'].PropTypes.bool,
        'isLogInButtonVisible': _react2['default'].PropTypes.bool,
        'isSignUpButtonVisible': _react2['default'].PropTypes.bool,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'loginEmailAddress': _react2['default'].PropTypes.string,
        'loginTargetUrl': _react2['default'].PropTypes.string,
        'signupTargetUrl': _react2['default'].PropTypes.string,
        'useRegularLink': _react2['default'].PropTypes.bool,
        'loginHeaderText': _react2['default'].PropTypes.string,
        'recaptchaPublicKey': _react2['default'].PropTypes.string,
        'displayCaptcha': _react2['default'].PropTypes.bool,
        'hideDropDownMenu': _react2['default'].PropTypes.bool,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'signupForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
    },

    getInitialState: function getInitialState() {
        return {
            'menuOpen': false
        };
    },

    toggleMenu: function toggleMenu() {
        this.setState({
            'menuOpen': !this.state.menuOpen
        });
    },

    componentDidMount: function componentDidMount() {
        this.addV2experimentListener();
        var container = $(".google-collapse");
        $(document).click(function (e) {
            if (container.html() != $(e.target).parent().parent().html()) {
                if (this.state.menuOpen) {
                    this.setState({
                        'menuOpen': false
                    });
                }
            }
        }.bind(this));
    },

    openMenu: function openMenu(e) {
        this.setState({
            'menuOpen': true
        });
    },

    setStateMousedOverDropDownMenuTrue: function setStateMousedOverDropDownMenuTrue() {
        this.setState({
            'mousedOverDropDownMenu': true
        });
    },

    setStateMousedOverDropDownMenuFalse: function setStateMousedOverDropDownMenuFalse() {
        this.setState({
            'mousedOverDropDownMenu': false
        });
    },

    closeMenu: function closeMenu() {
        var self = this;
        window.setTimeout(function () {
            if (self.state.mousedOverDropDownMenu !== true) {
                self.setState({
                    'menuOpen': false
                });
            }
        }, 200);
    },

    shouldRenderV2experiement: function shouldRenderV2experiement() {
        // Separate check for the window size here in addition to the
        // V2enabled switch to handle resizing
        if (window.innerWidth >= _topBarV.TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD) {
            if (this.state.V2enabled) {
                return true;
            }
        }

        return false;
    },

    addV2experimentListener: function addV2experimentListener() {
        var _this = this;

        window.addEventListener(_topBarV.TOP_BAR_V2_EXPERIMENT_NAME, function (e) {
            _this.setState({ V2enabled: true });
        });
    },

    render: function render() {

        var topBarMenuLinkDataSource = this.props.topBarMenuLinkData;

        if (this.shouldRenderV2experiement()) {
            Cookie.set(_topBarV.TOP_BAR_V2_EXPERIMENT_COOKIE_NAME, _topBarV.TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE);
            return this.renderV2();
        }

        var cx = _classnames2['default'];
        var linkClasses = {
            'm-link-list--link': true,
            'menu-link': true,
            'google-collapse': true,
            'c-white': this.props.useWhite ? true : false,
            'c-ashen': this.props.useWhite ? false : true,
            'hc-cerulean': this.props.useWhite ? false : true,
            'hc-warm-chinchilla': this.props.useWhite ? true : false,
            'show-for-medium-up': true
        };

        var mobileMenuIconClasses = {
            'm-link-list--menu-link-mobile-icon': true,
            'c-white': this.props.useWhite ? true : false,
            'c-ashen': this.props.useWhite ? false : true
        };

        var topBarMenuLinks = topBarMenuLinkDataSource.map(function (topBarMenuLink, i) {
            return _jsx(_topBarMenuLink2['default'], {
                componentName: topBarMenuLink.componentName ? topBarMenuLink.componentName : '',
                linkOptions: topBarMenuLink.options,
                linkOverrideColors: topBarMenuLink.linkOverrideColors,
                useWhite: this.props.useWhite,
                linkText: topBarMenuLink.text,
                linkUrl: topBarMenuLink.url,
                pageToHighLight: this.props.pageToHighLight ? this.props.pageToHighLight : ''
            }, i);
        }.bind(this));

        var menuIfOpen;
        if (this.state.menuOpen) {
            menuIfOpen = _jsx(_dropDownMenu2['default'], {
                style: { right: 40 },
                dropDownMenuLinkData: this.props.dropDownMenuLinkData
            });
        }

        var menu = _jsx('div', {
            className: 'm-link-list--link--container menu-container ' + (this.props.hideDropDownMenu ? 'is-hidden-on-large' : ''),
            onMouseEnter: this.openMenu,
            onMouseLeave: this.closeMenu
        }, void 0, _jsx('a', {
            href: 'javascript:;',
            className: cx(linkClasses),
            onClick: this.toggleMenu,
            tabIndex: '-1'
        }, void 0, _jsx('span', {}, void 0, 'MENU', _jsx('span', {
            className: 'm-link-list--menu-arrow'
        }, void 0, '▾'))), _jsx('div', {
            onMouseEnter: this.setStateMousedOverDropDownMenuTrue,
            onMouseLeave: this.setStateMousedOverDropDownMenuFalse
        }, void 0, menuIfOpen));

        var signUpButton;
        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
            signUpButton = _jsx(_signupButton2['default'], {
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact,
                signupForm: this.props.signupForm,
                loginForm: this.props.loginForm,
                recoverPasswordForm: this.props.recoverPasswordForm
            });
        }
        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
            signUpButton = _jsx(_signupButton2['default'], {
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact,
                signupUrl: this.props.signupTargetUrl,
                useRegularLink: this.props.useRegularLink,
                loginForm: this.props.loginForm,
                recoverPasswordForm: this.props.recoverPasswordForm,
                signupForm: this.props.signupForm
            });
        }

        var logInButton;
        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
            logInButton = _jsx(_loginButton2['default'], {
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                emailAddress: this.props.loginEmailAddress,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm
            });
        }
        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
            logInButton = _jsx(_loginButton2['default'], {
                emailAddress: this.props.loginEmailAddress,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
                loginUrl: this.props.loginTargetUrl,
                headerText: this.props.loginHeaderText,
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                displayCaptcha: this.props.displayCaptcha,
                useRegularLink: this.props.useRegularLink,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm
            });
        }

        return _jsx('div', {
            className: 'm-link-list small-9 columns text-center ' + (!this.props.isLogInButtonVisible && !this.props.isSignUpButtonVisible && this.props.hideDropDownMenu ? 'is-compact' : ''),
            'data-equalizer-watch': true
        }, void 0, menu, _jsx('a', {
            href: 'javascript:;',
            className: "toggle-nav m-link-list--menu-link-mobile" + (this.props.useWhite ? ' c-white hc-warm-chinchilla' : ' c-castle-rock hc-cerulean'),
            tabIndex: '-1'
        }, void 0, _jsx('span', {
            className: cx(mobileMenuIconClasses)
        })), logInButton, signUpButton, topBarMenuLinks);
    },

    renderV2: function renderV2() {

        var topBarMenuLinkDataSource = _topBarV.TOP_BAR_V2_EXPERIMENT_LINK_DATA;

        var topBarMenuLinks = topBarMenuLinkDataSource.map(function (topBarMenuLink, i) {
            return _jsx(_topBarMenuLink2['default'], {
                componentName: topBarMenuLink.componentName ? topBarMenuLink.componentName : '',
                linkOptions: topBarMenuLink.options,
                linkOverrideColors: topBarMenuLink.linkOverrideColors,
                useWhite: this.props.useWhite,
                linkText: topBarMenuLink.text,
                linkUrl: topBarMenuLink.url,
                pageToHighLight: this.props.pageToHighLight ? this.props.pageToHighLight : ''
            }, i);
        }.bind(this));

        var signUpButton;
        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
            signUpButton = _jsx(_signupButton2['default'], {
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact,
                signupUrl: this.props.signupTargetUrl,
                useRegularLink: this.props.useRegularLink,
                signupForm: this.props.signupForm,
                buttonText: 'SIGN UP FREE',
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm
            });
        }

        var logInButton;
        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
            logInButton = _jsx(_loginButton2['default'], {
                emailAddress: this.props.loginEmailAddress,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
                loginUrl: this.props.loginTargetUrl,
                headerText: this.props.loginHeaderText,
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                displayCaptcha: this.props.displayCaptcha,
                useRegularLink: this.props.useRegularLink,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm,
                className: 'experiment-top-bar-v2'
            }, void 0);
        }

        return _jsx('div', {
            className: 'm-link-list small-9 columns text-center ',
            'data-equalizer-watch': true
        }, void 0, logInButton, signUpButton, topBarMenuLinks);
    }
});

module.exports = TopBarMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/index.jsx
 ** module id = 765
 ** module chunks = 0
 **/